import * as React from 'react';

import { Header } from '../../components/Header';
import { HeaderRowContainer } from './parts/HeaderRow';
import { useSticky } from './helpers';
import { ClientComponent } from '../../components/ClientComponent';
import { DraggableHeaderRowContainer } from './parts/DraggableHeaderRow';

export interface IHeaderContainerProps {
  afterDragEnd?(): void;
  headRowRef: React.Ref<HTMLDivElement>;
  stickyRowRef: React.RefObject<HTMLTableRowElement>;
  onDragDrop?(state: boolean): void;
  onSticky(sticky: boolean): void;
  onUpdatePosition(position: number): void;
  position: number;
  prev: React.ReactNode;
}

export const HeaderContainer = ({
  afterDragEnd,
  headRowRef,
  stickyRowRef,
  onDragDrop,
  onSticky,
  onUpdatePosition,
  position,
  prev,
}: IHeaderContainerProps) => {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const sticky = useSticky({ containerRef: stickyRowRef, fallbackRef: containerRef });

  React.useEffect(() => {
    onSticky(sticky);
  }, [sticky]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Header ref={containerRef}>
      <ClientComponent
        replaceNode={<HeaderRowContainer headerRowRef={headRowRef} position={position} prev={prev} sticky={false} />}
      >
        <DraggableHeaderRowContainer
          headerRowRef={headRowRef}
          position={position}
          prev={prev}
          droppableId="header"
          afterDragEnd={afterDragEnd}
          onDragDrop={onDragDrop}
          onUpdatePosition={onUpdatePosition}
        />
        {sticky && (
          <DraggableHeaderRowContainer
            position={position}
            prev={prev}
            sticky
            droppableId="header-sticky"
            afterDragEnd={afterDragEnd}
            onDragDrop={onDragDrop}
            onUpdatePosition={onUpdatePosition}
          />
        )}
      </ClientComponent>
    </Header>
  );
};
